module.exports = __webpack_public_path__ + "static/media/checkbox-active.99ff7c18.svg";